webpackJsonp([135209972710757],{

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _components = __webpack_require__(3);
	
	var _marketing = __webpack_require__(8);
	
	var _blog = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Overview = function (_React$Component) {
	  _inherits(Overview, _React$Component);
	
	  function Overview(props) {
	    _classCallCheck(this, Overview);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this, props));
	  }
	
	  Overview.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'DocPage' },
	      _react2.default.createElement(_components.StripeBG, { bg2: "white", style: 'purple' }),
	      _react2.default.createElement(_marketing.Navbar, { className: 'grid-restrain' }),
	      _react2.default.createElement(
	        'section',
	        { className: 'grid-restrain grid-row full-8' },
	        _react2.default.createElement(_blog.DocToc, null),
	        _react2.default.createElement(
	          'div',
	          { className: 'content markdown-doc grid-item' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'title' },
	            'Variables'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Variables play a major role when scaling tests.  They give flexibility to both run tests against many environments and to also manage test data.  Some common uses are the base or launch url for your web application, api urls, login credentials, loop counters, etc.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'When recording a new test, SnapTest will auto-create a "baseUrl" variable, after which all other actions and assertions are relative to that baseUrl. this enables you to change environments with ease.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement('img', { src: 'https://res.cloudinary.com/snaptest/image/upload/v1551154598/docs/variables/autovar.gif' })
	          ),
	          _react2.default.createElement(
	            'h2',
	            { id: 'basic-usage-' },
	            'Variables in Action'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Variables are added to test actions in the "value" or "selector" fields. They are denoted using ',
	            "${ \<variablename\> }",
	            '.  All variables at this point are strings. '
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement('img', { src: 'https://res.cloudinary.com/snaptest/image/upload/v1551154851/docs/variables/vars.gif' })
	          ),
	          _react2.default.createElement(
	            'h2',
	            { id: 'basic-usage-' },
	            'Variable Source & Application Order'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Variables can potentially come from six different places:'
	          ),
	          _react2.default.createElement(
	            'ul',
	            null,
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'b',
	                null,
	                'Built-in System variables:'
	              ),
	              '  helper variables such as random integers.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'b',
	                null,
	                'Test default variables:'
	              ),
	              ' used as backups in case you don\'t have an environment specified.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'b',
	                null,
	                'Component default variables:'
	              ),
	              ' Similar to test default, but they also specify an interface for a component. '
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'b',
	                null,
	                'Environment Variables:'
	              ),
	              ' A powerful way to apply sets of variables to any tests.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'b',
	                null,
	                'Component Instance Variables:'
	              ),
	              ' Can accept all other variables as an input, thus being applied last for greatest flexibility.'
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                'b',
	                null,
	                'Dynamic Variables:'
	              ),
	              ' Applied on-the-fly using the "Add Dynamic Var" action.'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement('img', { src: 'https://res.cloudinary.com/snaptest/image/upload/v1551155014/docs/variables/Screen_Shot_2019-02-25_at_10.23.24_PM.png' })
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Variable values from the various sources are applied from top to bottom, overriding each other as they go. Notice that environment variables are applied next to last, so they will almost always override other variables except for component instance variables. Environment variables apply to all variables within component instances of a test.'
	          ),
	          _react2.default.createElement(
	            'h2',
	            { id: 'basic-usage-' },
	            'Variable Combining'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'You can combine/derive variables in environment and test/component sources. '
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'b',
	              null,
	              'Test default combining example:'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement('img', { src: 'https://res.cloudinary.com/snaptest/image/upload/v1551155466/docs/variables/Screen_Shot_2019-02-25_at_10.28.33_PM.png' })
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'b',
	              null,
	              'Environment variable combining example:'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement('img', { src: 'https://res.cloudinary.com/snaptest/image/upload/v1551155457/docs/variables/Screen_Shot_2019-02-25_at_10.30.42_PM.png' })
	          )
	        )
	      )
	    );
	  };
	
	  return Overview;
	}(_react2.default.Component);
	
	exports.default = Overview;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-doc-variables-js-ea617e17763e66011413.js